module.exports = __webpack_public_path__ + "img/1587837120.81725b8a.jpg";